import Tile01Jpg400 from "../../assets/imgs/tiles/responsive/tile-01-400.jpg"
import Tile01Jpg800 from "../../assets/imgs/tiles/responsive/tile-01-800.jpg"
import Tile01Webp400 from "../../assets/imgs/tiles/responsive/tile-01-400.webp"
import Tile01Webp800 from "../../assets/imgs/tiles/responsive/tile-01-800.webp"
import Tile02Jpg400 from "../../assets/imgs/tiles/responsive/tile-02-400.jpg"
import Tile02Jpg800 from "../../assets/imgs/tiles/responsive/tile-02-800.jpg"
import Tile02Webp400 from "../../assets/imgs/tiles/responsive/tile-02-400.webp"
import Tile02Webp800 from "../../assets/imgs/tiles/responsive/tile-02-800.webp"
import Tile03Jpg400 from "../../assets/imgs/tiles/responsive/tile-03-400.jpg"
import Tile03Jpg800 from "../../assets/imgs/tiles/responsive/tile-03-800.jpg"
import Tile03Webp400 from "../../assets/imgs/tiles/responsive/tile-03-400.webp"
import Tile03Webp800 from "../../assets/imgs/tiles/responsive/tile-03-800.webp"
import Tile04Jpg400 from "../../assets/imgs/tiles/responsive/tile-04-400.jpg"
import Tile04Jpg800 from "../../assets/imgs/tiles/responsive/tile-04-800.jpg"
import Tile04Webp400 from "../../assets/imgs/tiles/responsive/tile-04-400.webp"
import Tile04Webp800 from "../../assets/imgs/tiles/responsive/tile-04-800.webp"
import Tile05Jpg400 from "../../assets/imgs/tiles/responsive/tile-05-400.jpg"
import Tile05Jpg800 from "../../assets/imgs/tiles/responsive/tile-05-800.jpg"
import Tile05Webp400 from "../../assets/imgs/tiles/responsive/tile-05-400.webp"
import Tile05Webp800 from "../../assets/imgs/tiles/responsive/tile-05-800.webp"
import Tile06Jpg400 from "../../assets/imgs/tiles/responsive/tile-06-400.jpg"
import Tile06Jpg800 from "../../assets/imgs/tiles/responsive/tile-06-800.jpg"
import Tile06Webp400 from "../../assets/imgs/tiles/responsive/tile-06-400.webp"
import Tile06Webp800 from "../../assets/imgs/tiles/responsive/tile-06-800.webp"
import Tile07Jpg400 from "../../assets/imgs/tiles/responsive/tile-07-400.jpg"
import Tile07Jpg800 from "../../assets/imgs/tiles/responsive/tile-07-800.jpg"
import Tile07Webp400 from "../../assets/imgs/tiles/responsive/tile-07-400.webp"
import Tile07Webp800 from "../../assets/imgs/tiles/responsive/tile-07-800.webp"
import Tile08Jpg400 from "../../assets/imgs/tiles/responsive/tile-08-400.jpg"
import Tile08Jpg800 from "../../assets/imgs/tiles/responsive/tile-08-800.jpg"
import Tile08Webp400 from "../../assets/imgs/tiles/responsive/tile-08-400.webp"
import Tile08Webp800 from "../../assets/imgs/tiles/responsive/tile-08-800.webp"
import Tile09Jpg400 from "../../assets/imgs/tiles/responsive/tile-09-400.jpg"
import Tile09Jpg800 from "../../assets/imgs/tiles/responsive/tile-09-800.jpg"
import Tile09Webp400 from "../../assets/imgs/tiles/responsive/tile-09-400.webp"
import Tile09Webp800 from "../../assets/imgs/tiles/responsive/tile-09-800.webp"
import Tile10Jpg400 from "../../assets/imgs/tiles/responsive/tile-10-400.jpg"
import Tile10Jpg800 from "../../assets/imgs/tiles/responsive/tile-10-800.jpg"
import Tile10Webp400 from "../../assets/imgs/tiles/responsive/tile-10-400.webp"
import Tile10Webp800 from "../../assets/imgs/tiles/responsive/tile-10-800.webp"
import Asset01 from "../../assets/imgs/our-story/asset-01.webp"
import Asset02 from "../../assets/imgs/our-story/asset-02.webp"
import Asset03 from "../../assets/imgs/our-story/asset-03.webp"
import Asset04 from "../../assets/imgs/our-story/asset-04.webp"
import Asset05 from "../../assets/imgs/our-story/asset-05.webp"
import Asset06 from "../../assets/imgs/our-story/asset-06.webp"
import Asset07 from "../../assets/imgs/our-story/asset-07.webp"
import Asset08 from "../../assets/imgs/our-story/asset-08.webp"
import Asset09 from "../../assets/imgs/our-story/asset-09.webp"
import Asset10 from "../../assets/imgs/our-story/asset-10.webp"
import Asset11 from "../../assets/imgs/our-story/asset-11.webp"
import Asset12 from "../../assets/imgs/our-story/asset-12.webp"
import Asset13 from "../../assets/imgs/our-story/asset-13.webp"
import Asset14 from "../../assets/imgs/our-story/asset-14.webp"
import Asset15 from "../../assets/imgs/our-story/asset-15.webp"
import Asset16 from "../../assets/imgs/our-story/asset-16.webp"
import Asset17 from "../../assets/imgs/our-story/asset-17.webp"
import Asset18 from "../../assets/imgs/our-story/asset-18.webp"
import Asset19 from "../../assets/imgs/our-story/asset-19.webp"
import Asset20 from "../../assets/imgs/our-story/asset-20.webp"
import Asset21 from "../../assets/imgs/our-story/asset-21.webp"
import BurnPaper from "../../assets/imgs/our-story/burn-paper.webp"
import Paper from "../../assets/imgs/our-story/paper.webp"
import OldPaper from "../../assets/imgs/our-story/old-paper.webp"
import Papers from "../../assets/imgs/our-story/papers.webp"
import VintageBook from "../../assets/imgs/our-story/vintage-book.webp"
import Letter from "../../assets/imgs/our-story/letter.webp"
import Left from '../../assets/imgs/di-sini/content1.jpg'
import Mid from '../../assets/imgs/di-sini/content2.jpg'
import Right from '../../assets/imgs/di-sini/content3.jpg'
import Reservation from '../../assets/imgs/di-sini/reservation/two-waitress.jpg'
import Menus from '../../assets/imgs/di-sini/menus.jpg'
import SpecialEvent from '../../assets/imgs/di-sini/special-events.jpeg'
import FrontElevation from '../../assets/imgs/di-sini/front-elevation.jpg'
import LeftElevation from '../../assets/imgs/di-sini/left-elevation.jpg'
import Umbrella from '../../assets/imgs/di-sini/umbrella.png'
import Img02 from "../../assets/imgs/our-story/rachman-and-sons/jonathan-ivan-and-alain.jpg"
import Img01 from "../../assets/imgs/our-story/rachman-and-sons/img-01.webp"
import Paper2 from "../../assets/imgs/our-story/rachman-and-sons/paper.webp"
import PaperMob from "../../assets/imgs/our-story/rachman-and-sons/paper-mob.webp"
import RightPaper from "../../assets/imgs/our-story/the-loro-blonyo/right-paper.webp"
import LeftPaper from "../../assets/imgs/our-story/the-loro-blonyo/left-paper.webp"
import Cover from "../../assets/imgs/our-story/the-loro-blonyo/cover.webp"
import WrittenPaper from "../../assets/imgs/our-story/the-loro-blonyo/written-paper.webp"
import TuckedPaper from "../../assets/imgs/our-story/the-loro-blonyo/tucked-paper.webp"
import PaperClip from "../../assets/imgs/our-story/the-loro-blonyo/paper-clip.png"
import SkyCouple from "../../assets/imgs/our-story/the-loro-blonyo/sky-couple.png"
import ImgTLB02 from "../../assets/imgs/our-story/the-loro-blonyo/img-02.webp"
import ImgTLB01 from "../../assets/imgs/our-story/the-loro-blonyo/img-01.webp"
import ImgTLB03 from "../../assets/imgs/our-story/the-loro-blonyo/img-03.webp"
import ImgTLB04 from "../../assets/imgs/our-story/the-loro-blonyo/img-04.webp"
import ImgPCP1400 from "../../assets/imgs/di-sana/porcelain-catalog/products/charger-1-400.webp"
import ImgPCP1800 from "../../assets/imgs/di-sana/porcelain-catalog/products/charger-1-800.webp"
import ImgPCP2400 from "../../assets/imgs/di-sana/porcelain-catalog/products/charger-2-400.webp"
import ImgPCP2800 from "../../assets/imgs/di-sana/porcelain-catalog/products/charger-2-800.webp"
import ImgPCP3400 from "../../assets/imgs/di-sana/porcelain-catalog/products/dinner-plate-400.webp"
import ImgPCP3800 from "../../assets/imgs/di-sana/porcelain-catalog/products/dinner-plate-800.webp"
import ImgPCP4400 from "../../assets/imgs/di-sana/porcelain-catalog/products/dessert-plate-400.webp"
import ImgPCP4800 from "../../assets/imgs/di-sana/porcelain-catalog/products/dessert-plate-800.webp"
import ImgPCP5400 from "../../assets/imgs/di-sana/porcelain-catalog/products/cup-and-saucer-set-400.webp"
import ImgPCP5800 from "../../assets/imgs/di-sana/porcelain-catalog/products/cup-and-saucer-set-800.webp"
import ImgPCP6400 from "../../assets/imgs/di-sana/porcelain-catalog/products/side-plate-400.webp"
import ImgPCP6800 from "../../assets/imgs/di-sana/porcelain-catalog/products/side-plate-800.webp"
import ImgPCP7400 from "../../assets/imgs/di-sana/porcelain-catalog/products/butter-dish-400.webp"
import ImgPCP7800 from "../../assets/imgs/di-sana/porcelain-catalog/products/butter-dish-800.webp"
import { faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons"

const menu = [
  {
    label: "our story",
    link: "/our-story",
    details: [
      { name: "The Loro Blonyo", link: "/our-story/the-loro-blonyo" },
      { name: "Rachman and Sons", link: "/our-story/rachman-and-sons" },
      { name: "What We Believe", link: "/our-story/what-we-believe" },
      { name: "Our Ohana", link: "/our-story/our-ohana" }
    ]
  },
  {
    label: "restaurant/di sini",
    link: "/di-sini",
    details: [
      { name: "Reservation", link: "/di-sini/reservation" },
      { name: "Menus", link: "/di-sini/menus" },
      { name: "Special Events", link: "/di-sini/special-events" }
    ]
  },
  {
    label: "store/di sana",
    link: "/di-sana",
    details: [
      // { name: "Loro Blonyo Fine Porcelain", link: "/di-sana/loro-blonyo-fine-porcelain" },
      { name: "Return Policy", link: "/di-sana/return-policy" },
      { name: "Shipping Policy", link: "/di-sana/shipping-policy" },
      { name: "FAQ", link: "/di-sana/faq" },
      // { name: "Announcements", link: "/di-sana/announcements" }
    ]
  },
  {
    label: "cultural events",
    link: "/cultural-events",
  },
  { label: "gallery", link: "/gallery" },
  { label: "philanthropy", link: "/philanthropy" },
  {
    label: "garlic peanut story",
    isBlank: true,
    link: "https://thegarlicpeanutstory.com/",
  },
  {
    label: "jonathan rachman design",
    isBlank: true,
    link: "https://www.jonathanrachman.com/",
  },
  {
    label: "press",
    link: "/press"
  },
  {
    label: "blogs",
    link: "/blogs"
  }
]

const tiles = [
  {
    title: "our story",
    link: "/our-story",
    img: {
      src: Tile01Jpg400,
      srcSet: `${Tile01Jpg400} 400w, ${Tile01Jpg800} 800w`,
      webpSrcSet: `${Tile01Webp400} 400w, ${Tile01Webp800} 800w`
    }
  },
  {
    title: "di sini",
    link: "/di-sini",
    img: {
      src: Tile02Jpg400,
      srcSet: `${Tile02Jpg400} 400w, ${Tile02Jpg800} 800w`,
      webpSrcSet: `${Tile02Webp400} 400w, ${Tile02Webp800} 800w`
    }
  },
  {
    title: "di sana",
    link: "/di-sana",
    img: {
      src: Tile03Jpg400,
      srcSet: `${Tile03Jpg400} 400w, ${Tile03Jpg800} 800w`,
      webpSrcSet: `${Tile03Webp400} 400w, ${Tile03Webp800} 800w`
    }
  },
  {
    title: "gallery",
    link: "/gallery",
    img: {
      src: Tile04Jpg400,
      srcSet: `${Tile04Jpg400} 400w, ${Tile04Jpg800} 800w`,
      webpSrcSet: `${Tile04Webp400} 400w, ${Tile04Webp800} 800w`
    }
  },
  {
    title: "cultural events",
    link: "/cultural-events",
    img: {
      src: Tile05Jpg400,
      srcSet: `${Tile05Jpg400} 400w, ${Tile05Jpg800} 800w`,
      webpSrcSet: `${Tile05Webp400} 400w, ${Tile05Webp800} 800w`
    }
  },
  {
    title: "philanthropy",
    link: "/philanthropy",
    img: {
      src: Tile06Jpg400,
      srcSet: `${Tile06Jpg400} 400w, ${Tile06Jpg800} 800w`,
      webpSrcSet: `${Tile06Webp400} 400w, ${Tile06Webp800} 800w`
    }
  },
  {
    title: "garlic peanut story",
    link: "https://thegarlicpeanutstory.com/",
    isBlank: true,
    img: {
      src: Tile07Jpg400,
      srcSet: `${Tile07Jpg400} 400w, ${Tile07Jpg800} 800w`,
      webpSrcSet: `${Tile07Webp400} 400w, ${Tile07Webp800} 800w`
    }
  },
  {
    title: "jonathan rachman design",
    link: "https://jonathanrachman.com/",
    isBlank: true,
    img: {
      src: Tile08Jpg400,
      srcSet: `${Tile08Jpg400} 400w, ${Tile08Jpg800} 800w`,
      webpSrcSet: `${Tile08Webp400} 400w, ${Tile08Webp800} 800w`
    }
  },
  {
    title: "press",
    link: "/press",
    img: {
      src: Tile09Jpg400,
      srcSet: `${Tile09Jpg400} 400w, ${Tile09Jpg800} 800w`,
      webpSrcSet: `${Tile09Webp400} 400w, ${Tile09Webp800} 800w`
    }
  },
  {
    title: "contact us",
    link: "/di-sini/special-events#contactUs",
    img: {
      src: Tile10Jpg400,
      srcSet: `${Tile10Jpg400} 400w, ${Tile10Jpg800} 800w`,
      webpSrcSet: `${Tile10Webp400} 400w, ${Tile10Webp800} 800w`
    }
  }
]

const bioPs = [
  "Founded by Jonathan Rachman the internationally noted interior designer and author, DI SINI DI SANA by Rachman & Sons is more than a restaurant and boutique - it is a lifestyle designed to capture the experiences and accumulated skills and talents of our family through three generations.",
  "It is rooted and inspired by the love of our parents and grandparents in a new special singular venue in Ubud.",
  " It is a special gathering place so worthy of our East - West cuisine, drinks, and beautiful products all delivered with love inspired by our parents and grandparents.",
  "The theme of DI SINI DI SANA is Here and There, East and West. We are excited to share this gem created for you in a classic and current design delivering hospitality, cuisine, arts and crafts created with love, for you to  experience remember and cherish in a special way and  place.",
]

const wwbList = [
  "In continuing our Papi and Mami’s names and legacy by sharing their generosity and love with action",
  "In faith, hope and love, while always aware that the greatest one of all is LOVE: these are the words and teachings our parents shared with us",
  "In sharing our knowledge and blessings not only with the people with whom we routinely collaborate but with strangers we encounter",
  "In peace and equality for all humans",
  "In positive, loving intentions",
  "In doing business with love, kindness and compassion and to choose to do business only with those who are kind and fair, respectful and believe in the betterment of humanity",
  "In being responsible business owners: to have integrity in everything we do",
  "In giving back to our communities where we were born, raised and educated and now where we live and wherever we do business",
  "In our responsibility to preserve our culture, skills and crafts, to improve on them and to pass them on to future generations",
  "In being constantly inspired and develop our products to inspire",
  "In beauty in everything we make, serve and do, which includes our products, packaging, environmental awareness and services",
  "In producing, offering and selling the best product quality",
  "In collaboration: with our purveyors, distributors and clients",
  "In paying our craft women and men fairly, always valuing them fairly",
  "In the spirit of hospitality by serving our clients with sincerity and kindness and to deliver what we promise and beyond",
  "In ‘old school’ hospitality and traditions, which are beautiful; and it is our job to honor and continue these traditions",
  "In bringing the best from both the East and the West as they juxtapose beautifully and harmoniously by producing and showcasing, offering, selling and using our products and services"
]

const RASParagraphs = [
  "After almost four decades of living abroad and in the Western hemisphere, I, the island boy, Jonathan Rachman, am coming home!",
  "Together with my fairy god sons Ivan and Alain, I am bringing the best of both worlds: what I have learned, experienced and lived through in the West is being brought home and combined with my experiences in the East: the love of my parents, memories and life in my home country of Indonesia.",
  "DI SINI DI SANA by Rachman & Sons is inspired by our love of our role models, the Loro Blonyo: the inseparable couple - my Papi and Mami who devoted their life not only to love each other, but to their family, home and humanity. They taught me to be open minded, to try new experiences in life and to travel the world. I feel extremely lucky, blessed and fortunate to have been given a chance to see and explore the world. I always feel that out of millions and millions of Indonesians throughout generations, I was blessed with the opportunity to see what the world has to offer. I want to share my love of hospitality, gorgeous quality things, alongwith my childhood memories of beauty - full, well made items which are crafted in my home country, Indonesia, all while implementing my obsession with the luxurious world of the classic, highest quality crafts I have encountered throughout my life.",
  "Together with my beloved fairy god sons Ivan and Alain, both of whom are on my favorite island of Bali, we begin the new phase of our family journey as we continue our family legacy now adding our visions and beliefs in continuing the love of our parents and grandparents while preserving childhood memories, traditions and culture for the next generations to come. Through DI SINI DI SANA by Rachman & Sons, we want to share the products and services we have designed with our heart and love in hope that you will continue to share our parents’ love story and spread their love - this is our way to pay it forward with everyone not just in our home country but strangers we encounter as we travel the world.",
  "Please peruse and enjoy our labor of love in this first issue of our look book and we hope you will continue to share our love story...",
  "In Bahasa Indonesia, we say “Terima Kasih” - literally means: Please accept our LOVE,",
  "Jonathan, Ivan & Alain"
]

const TLBParagraphs = [
  "When invited by de Gournay, the London based bespoke hand-painted wallpaper company, to design a custom wallpaper with animal theme, Jonathan used the opportunity to express his admiration and love of and for  his parents symbolically.",
  "He ‘turned’ his beloved Mami and Papi - his Mom and Dad - into the legendary Ubud Monkey as a couple – the Loro Blonyo,  referencing the \“Inseparable Couple\”, traditional Javanese figures that represent a pair of lovers,  often given as wedding presents.",
  "Here, in his wallpaper as produced in collaboration with de Gournay, he has illustrated the relationship, somewhat cheekily, with monkeys.",
  "\“As the show’s theme was ‘Animalia: Animal Imagery in Antiques and Art,’ I turned my parents into Balinese monkeys from the Ubud Monkey Forest,” explains Rachman. “Legend says that these primates were the descendants of the royal family. While my parents are not royal consorts of any sort, in my heart, they are the true royal lovers.\”",
  "The fanciful landscape in which the monkeys frolic is an homepage to his homeland and the lush greenery of his favorite island, Bali. Temples and traditional dwellings can be seen beyond the checkered umbrellas and through the palm trees, plants and orchids, as fishing boats sail along the river. It’s an idyllic scene that is pure fantasy, yet it intrinsically reflects who Rachman is. Besides whimsical, it is truly romantic and sentimental as that was what he witnessed as a child and throughout his life: he always saw his parents holding hands every time they went somewhere, openly showing affection towards each other. In fact, during their last anniversary (sadly his father passed away over two years ago), Jonathan was again able to witness their love for each other, upclose and personal when the couple celebrated their 65th anniversary.",
  "Two months later his father passed away.",
  "Here are some images from the day they got married, during their honeymoon and throughout their lives, holding on to each other.",
  "At DI SINI DI SANA, the Loro Blonyo does not only inspire us to continue their legacy, they are forever our mascot of LOVE! Thus, their story has become our own mythical legend…"
]

const diSiniPs = [
  "Traditional Eastern motifs will be joined with elegant Western interior design to create an atmosphere in East-West harmony, which we call DI SINI DI SANA.",
  "Much more than decoration, our classic tiles symbolize a commitment to respect and preserve our local crafts and culture - providing our guests, our friends, a cozy, comfortable experience of Eastern hospitality in Western elegance.",
  "We are excited to welcome you soon to immerse yourself in DI SINI DI SANA culture. When our doors open you will enjoy delicious dishes while surrounded by a well designed and comfortable space.",
  "You will also discover unique products each with their own story inspired by our Eastern roots and by classic Western elements.",
  "That is DI SINI DI SANA!"
]

const diSanaStores = [
  // { title: "Announcements", link: "/di-sana/announcements" },
  { title: "FAQ", link: "/di-sana/faq" },
  { title: "Return Policy", link: "/di-sana/return-policy" },
  { title: "Shipping Policy", link: "/di-sana/shipping-policy" },
]

const diSanaReturnPs = [
  "All antique and vintage sales are final.",
  "On new products (including the J.Rachman leather line), we will honor store credit or exchange within 14 days, if returned in original condition, unused and with a receipt."
]

const diSanaShippingPs = [
  "We cannot confirm the price of an item until you order; however, we do not charge your credit card until after your order has entered the shipping process.",
  "By registering an account with JRD, your checkout will be quicker and more efficient, with easy access to your order history and shipping preferences. If you're not comfortable shopping online and wish to phone in your order, you are welcome to do so.",
  "All items purchased, earned, or otherwise ordered from the Services are made pursuant to the terms of the specific shipment contract. This means that the risk of loss and title for such items pass to you upon our delivery to the carrier."
]

const diSanaQs = [
  {
    id: 1,
    title: "What is your return or exchange policy?",
    detail: "We accept store credit or exchanges within 14 days of purchase, provided that the item is returned in its original condition, unused, and accompanied by a receipt. We cannot process returns for items that have been used, damaged due to customer negligence, or without proof of purchase."
  },
  {
    id: 2,
    title: "How does DSDS use and protect my personal information?",
    detail: "DSDS collects and uses your personal information only as needed to operate our business and provide you with the best possible products and services. This includes using your information to process orders, offer personalized recommendations, improve our services, and ensure the security and proper functioning of our platform."
  },
  {
    id: 3,
    title: "Who is responsible if my order is lost or damaged during shipping?",
    detail: "All shipments are made under a standard shipping contract. This means that the risk of loss or damage passes to the customer once we deliver the package to the carrier. If any issue occurs after the shipment has been handed over, please contact the shipping provider directly using your tracking number."
  },
]

const cEsSubMenus = [
  { name: "Upcoming Events", slug: "upcoming-events", time_type: 1 },
  { name: "Past Events", slug: "past-events", time_type: 0 }
]

const purchaseTabTables = [
  { idx: 0, tabId: "tabAll", name: "All", status: "all" },
  { idx: 1, tabId: "tabToPay", name: "To Pay", status: "to_pay" },
  { idx: 2, tabId: "tabToShip", name: "To Ship", status: "to_ship" },
  { idx: 3, tabId: "tabToReceive", name: "To Receive", status: "to_receive" },
  { idx: 4, tabId: "tabCompleted", name: "Completed", status: "completed" },
  { idx: 5, tabId: "tabCompleted", name: "Cancelled", status: "canceled" },
  { idx: 6, tabId: "tabFailed", name: "Failed", status: "failed" },
  // { id: 7, tabId: "tabReturnRefund", slug: "return-refund", name: "Return Refund" },
]

const purchaseStatus = [
  { id: 0, status: "all" },
  { id: 1, status: "pending" },
  { id: 2, status: "paid" },
  { id: 6, status: "failed" },
]

const paymentStatus = ["to_pay", "to_ship", "to_receive", "completed", "canceled", "failed"]

const porcelainCatalogContents = {
  subtitle: "A favourite for classic tableware.",
  paragraphs: [
    "Inspired by the love of our founder's parents, each piece of The Loro Blonyo Fine Porcelain Collection embodies timeless elegance and refined simplicity. Developed from traditional porcelain techniques, it offers a refined look while remaining practical for everyday use.",
    "With its pure white tone, subtle sheen, and blue and gold detailing, this collection brings a sense of heritage into contemporary living, suitable for both daily dining and special occasions."
  ]
}

const porcelainCatalogProducts = [
  {
    name: "Charger 1",
    img: {
      src: ImgPCP1400,
      srcSet: `${ImgPCP1400} 400w, ${ImgPCP1800} 800w`
    },
    variant: "Big Greek Fret",
    isSingle: false,
    weight: 1050,
    diameter: 34,
    thickness: 3.5,
    price: 1645000
  },
  {
    name: "Charger 2",
    img: {
      src: ImgPCP2400,
      srcSet: `${ImgPCP2400} 400w, ${ImgPCP2800} 800w`
    },
    variant: "Small Greek Fret",
    isSingle: false,
    weight: 1050,
    diameter: 34,
    thickness: 3.5,
    price: 1345000
  },
  {
    name: "Dinner Plate",
    img: {
      src: ImgPCP3400,
      srcSet: `${ImgPCP3400} 400w, ${ImgPCP3800} 800w`
    },
    variant: null,
    isSingle: false,
    weight: 867,
    diameter: 28.3,
    thickness: 3.35,
    price: 1035000
  },
  {
    name: "Dessert Plate",
    img: {
      src: ImgPCP4400,
      srcSet: `${ImgPCP4400} 400w, ${ImgPCP4800} 800w`
    },
    variant: null,
    isSingle: false,
    weight: 545,
    diameter: 22.3,
    thickness: 2.2,
    price: 615000
  },
  {
    name: "Cup & Saucer Set",
    img: {
      src: ImgPCP5400,
      srcSet: `${ImgPCP5400} 400w, ${ImgPCP5800} 800w`
    },
    variant: null,
    isSingle: true,
    types: [
      {
        name: "SAUCER",
        weight: 225,
        diameter: 15.3,
        thickness: 2.1
      },
      {
        name: "CUP",
        weight: 175,
        diameter: 10,
        thickness: 6.6,
      }
    ],
    price: 885000
  },
  {
    name: "Bread & Butter / Side Plate",
    img: {
      src: ImgPCP6400,
      srcSet: `${ImgPCP6400} 400w, ${ImgPCP6800} 800w`
    },
    variant: null,
    isSingle: false,
    weight: 220,
    diameter: 16.7,
    thickness: 1.9,
    price: 495000
  },
  {
    name: "Sauce / Butter Dish",
    img: {
      src: ImgPCP7400,
      srcSet: `${ImgPCP7400} 400w, ${ImgPCP7800} 800w`
    },
    variant: null,
    isSingle: false,
    weight: 117,
    diameter: 10.6,
    thickness: 1.5,
    price: 255000
  }
]

const oneSetPorcelain = {
  products: [
    "2 Chargers (Big Greek Fret & Small Greek Fret)",
    "1 Dinner Plate",
    "1 Dessert Plate",
    "1 Cup & Saucer Set",
    "1 Bread & Butter / Side Plate",
    "1 Sauce / Butter Dish"
  ],
  price: 5755000,
  amount: 8
}

const PorcelainCatalogOrderInstruction = [
  {
    step: "01",
    instruction: "Select your desired pieces"
  },
  {
    step: "02",
    instruction: "Share the item name, quantity, and your delivery details with us via:",
    options: [
      {
        method: "WhatsApp",
        icon: faWhatsapp,
        detail: "+62 812-3867-9998",
        link: "https://wa.me/6281238679998"
      },
      {
        method: "Email",
        icon: faEnvelope,
        detail: "loroblonyo@disinidisanabras.com",
        link: "mailto:loroblonyo@disinidisanabras.com"
      },
      {
        method: "Instagram",
        icon: faInstagram,
        detail: "disinidisanabras",
        link: "https://www.instagram.com/disinidisanabras"
      },
      {
        method: "Website",
        icon: faGlobe,
        detail: "www.disinidisanabras.com",
        link: "https://disinidisanabras.com"
      },
    ]
  },
  {
    step: "03",
    instruction: "We will confirm availability and provide payment instructions."
  },
  {
    step: "04",
    instruction: "Your order will be carefully packed and prepared for delivery."
  },
]

// images
const ourStoryImgs = [
  Asset01,
  Asset02,
  Asset03,
  Asset04,
  Asset05,
  Asset06,
  Asset07,
  Asset08,
  Asset09,
  Asset10,
  Asset11,
  Asset12,
  Asset13,
  Asset14,
  Asset15,
  Asset16,
  Asset17,
  Asset18,
  Asset19,
  Asset20,
  Asset21,
  BurnPaper,
  Paper,
  OldPaper,
  Papers,
  VintageBook,
  Letter
]

const rachmanAndSonsImgs = [
  Img02,
  Img01,
  Paper2,
  PaperMob
]

const theLoroBlonyoImgs = [
  RightPaper,
  LeftPaper,
  Cover,
  WrittenPaper,
  TuckedPaper,
  PaperClip,
  SkyCouple,
  ImgTLB02,
  ImgTLB01,
  ImgTLB03,
  ImgTLB04
]

const diSiniImgs = {
  slides: [
    "bg-[url('/src/assets/imgs/di-sini/slideshow1.jpg')]",
    "bg-[url('/src/assets/imgs/di-sini/slideshow2.jpg')]",
    "bg-[url('/src/assets/imgs/di-sini/slideshow3.jpg')]",
    "bg-[url('/src/assets/imgs/di-sini/slideshow4.jpg')]",
    "bg-[url('/src/assets/imgs/di-sini/slideshow5.jpg')]",
    "bg-[url('/src/assets/imgs/di-sini/slideshow6.jpeg')]",
  ],
  contents: [
    Left, Mid, Right
  ],
  menus: [
    {
      imgPath: Reservation,
      title: "Reservation",
      text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed ed",
      link: "/di-sini/reservation"
    },
    {
      imgPath: Menus,
      title: "Menus",
      text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed ed",
      link: "/di-sini/menus"
    },
    {
      imgPath: SpecialEvent,
      title: "Special Event",
      text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed ed",
      link: "/di-sini/special-events"
    }
  ],
  elevations: [
    FrontElevation, Umbrella, LeftElevation
  ]
}

const diSanaImgs = {
  slides: [
    "bg-[url('/src/assets/imgs/di-sana/slideshow1.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow2.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow3.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow4.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow5.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow6.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow7.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow8.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slideshow9.jpg')]",
    "bg-[url('/src/assets/imgs/di-sana/slide-09.jpg')]",
  ]
}

const galleryImgs = {
  slides: ["bg-[url(/src/assets/imgs/gallery/banner.jpg)]"],
}

export {
  menu,
  tiles,
  bioPs,
  diSiniPs,
  ourStoryImgs,
  wwbList,
  RASParagraphs,
  TLBParagraphs,
  diSiniImgs,
  diSanaStores,
  diSanaImgs,
  diSanaReturnPs,
  diSanaShippingPs,
  diSanaQs,
  cEsSubMenus,
  galleryImgs,
  rachmanAndSonsImgs,
  theLoroBlonyoImgs,
  purchaseTabTables,
  purchaseStatus,
  paymentStatus,
  porcelainCatalogContents,
  oneSetPorcelain,
  porcelainCatalogProducts,
  PorcelainCatalogOrderInstruction
}
